import { useQuery } from '@tanstack/react-query';

import { useProfile } from '../profile';

import { sdk } from '@/services';

const EventService = sdk.getService('EventService');

export const useStudentLiveClassesStats = () => {
  const {
    profile,
    roleCheck: { isStudent }
  } = useProfile();

  const userId = profile?._id;

  const { data, isLoading, error } = useQuery({
    queryKey: ['student-live-classes-stats', userId],
    queryFn: () => EventService.getStudentLiveClassesStats(),
    enabled: !!userId && isStudent
  });

  const seenClasses = data?.seen ?? 0;
  const totalClasses = seenClasses + (data?.notSeen ?? 0);

  return {
    seenClasses,
    totalClasses,
    notSeenClasses: data?.notSeen ?? 0,
    isLoading,
    error
  };
};
